module.exports = __webpack_public_path__ + "assets/img/weixin_icon.d25b5c58.png";